export function toEmbedUrl(url) {
  if (!url) return null;
  try {
    const u = new URL(url.trim());
    const host = u.hostname.replace(/^www\./, "");
    if (host === "youtu.be") return `https://www.youtube.com/embed/${u.pathname.slice(1)}?autoplay=1&mute=1&playsinline=1`;
    if (host.endsWith("youtube.com")) {
      const id = u.searchParams.get("v") || u.pathname.match(/\/(live|embed|shorts)\/([^/?]+)/)?.[2];
      if (id) return `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&playsinline=1`;
    }
    if (host.endsWith("vimeo.com")) {
      const id = u.pathname.match(/\/(?:video\/|event\/)?(\d+)/)?.[1];
      if (id) return `https://player.vimeo.com/video/${id}?autoplay=1&muted=1`;
    }
    if (host.endsWith("twitch.tv")) {
      const channel = u.pathname.split("/").filter(Boolean)[0];
      if (channel) return `https://player.twitch.tv/?channel=${channel}&parent=${window.location.hostname}&muted=true`;
    }
    return url;
  } catch (e) {
    return null;
  }
}
